import { ROTULO_STATUS_ALUNO } from '@arena/shared/schemas';
import { alunosApi } from '../api/alunos.js';
import { registrarFonteDeBusca, type ResultadoDeBusca } from '../shell/buscaGlobal.js';
import { telefoneFormatado } from './formatos.js';

/**
 * A fonte `alunos` da busca global da topbar (documento 05, tarefa 11) —
 * a referência viva do padrão descrito em `shell/buscaGlobal.ts`.
 *
 * Importado por efeito colateral em `App.tsx`, uma vez: importar o
 * arquivo já registra a fonte, antes de qualquer render do `Shell`.
 *
 * A mesma busca por trecho de nome, telefone ou CPF de `#v-alunos` —
 * `alunosApi.listar` já normaliza sem acento no servidor —, limitada a
 * 5 resultados: é um painel de sugestão, não uma segunda listagem.
 */
registrarFonteDeBusca({
  chave: 'alunos',
  rotulo: 'Alunos',
  exige: { recurso: 'alunos', acao: 'ler' },
  async buscar(termo): Promise<ResultadoDeBusca[]> {
    const pagina = await alunosApi.listar({ busca: termo, limite: 5 });
    return pagina.itens.map((aluno) => ({
      id: aluno.id,
      titulo: aluno.nome,
      subtitulo: [ROTULO_STATUS_ALUNO[aluno.status], telefoneFormatado(aluno.telefone)]
        .filter((parte) => parte && parte !== '—')
        .join(' · '),
      icone: 'users',
      // `#v-alunos` lê `?aluno=` para abrir a ficha direto — o mesmo
      // padrão de `?marcacao=` na agenda.
      rota: `/alunos?aluno=${aluno.id}`,
    }));
  },
});
